import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { presetToHours } from '../hooks/useDashboard';
const presets = [
    { key: '1h', label: '1 Hour' },
    { key: '6h', label: '6 Hours' },
    { key: '24h', label: '24 Hours' },
    { key: '7d', label: '7 Days' },
    { key: '30d', label: '30 Days' },
];
export function DateRangeFilter({ dateRange, onDateRangeChange }) {
    const [showCustom, setShowCustom] = useState(false);
    const [customStart, setCustomStart] = useState('');
    const [customEnd, setCustomEnd] = useState('');
    const handlePresetClick = (preset) => {
        if (preset === 'custom') {
            setShowCustom(true);
        }
        else {
            setShowCustom(false);
            onDateRangeChange({ preset });
        }
    };
    const handleCustomApply = () => {
        if (customStart && customEnd) {
            const start = new Date(customStart);
            const end = new Date(customEnd);
            if (start < end) {
                onDateRangeChange({ preset: 'custom', start, end });
                setShowCustom(false);
            }
        }
    };
    const getCurrentHours = () => {
        if (dateRange.preset === 'custom' && dateRange.start && dateRange.end) {
            const hours = Math.round((dateRange.end.getTime() - dateRange.start.getTime()) / (1000 * 60 * 60));
            return `${hours}h`;
        }
        const presetHours = presetToHours(dateRange.preset);
        return presetHours >= 24 ? `${presetHours / 24}d` : `${presetHours}h`;
    };
    return (_jsxs("div", { className: "relative", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("span", { className: "text-sm text-gray-500 mr-2", children: "Time Range:" }), presets.map(preset => (_jsx("button", { onClick: () => handlePresetClick(preset.key), className: `
              px-3 py-1.5 rounded-lg text-sm font-medium transition-colors
              ${dateRange.preset === preset.key && !showCustom
                            ? 'bg-blue-100 text-blue-700'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}
            `, children: preset.label }, preset.key))), _jsx("button", { onClick: () => handlePresetClick('custom'), className: `
            px-3 py-1.5 rounded-lg text-sm font-medium transition-colors
            ${showCustom
                            ? 'bg-blue-100 text-blue-700'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}
          `, children: "Custom" }), _jsx("span", { className: "ml-2 px-2 py-1 bg-gray-50 rounded text-xs text-gray-500", children: getCurrentHours() })] }), showCustom && (_jsxs("div", { className: "absolute top-full left-0 mt-2 p-4 bg-white rounded-lg shadow-lg border border-gray-200 z-50 w-80", children: [_jsx("h3", { className: "text-sm font-semibold text-gray-900 mb-3", children: "Custom Date Range" }), _jsxs("div", { className: "space-y-3", children: [_jsxs("div", { children: [_jsx("label", { className: "block text-xs text-gray-500 mb-1", children: "Start" }), _jsx("input", { type: "datetime-local", value: customStart, onChange: (e) => setCustomStart(e.target.value), className: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" })] }), _jsxs("div", { children: [_jsx("label", { className: "block text-xs text-gray-500 mb-1", children: "End" }), _jsx("input", { type: "datetime-local", value: customEnd, onChange: (e) => setCustomEnd(e.target.value), className: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" })] }), _jsxs("div", { className: "flex gap-2 pt-2", children: [_jsx("button", { onClick: handleCustomApply, disabled: !customStart || !customEnd, className: "flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed", children: "Apply" }), _jsx("button", { onClick: () => setShowCustom(false), className: "px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200", children: "Cancel" })] })] })] }))] }));
}
